export default "__VITE_ASSET__B00Gj9nW__"